import { authedAxios } from '../../utils'
import { useEffect, useState } from 'react'

const useGenericEndpoint = (
  url,
  { shouldPreventCall, shouldDelayCall, filters } = {}
) => {
  const [data, setData] = useState(null)

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)

  const fetchData = () => {
    let urlWithParams = url

    if (filters) {
      Object.keys(filters).forEach((key) => {
        const value = filters[key]
        const isArray = Array.isArray(value)
        const normalizedValue = isArray ? JSON.stringify(value) : value

        if (normalizedValue && normalizedValue !== '[]') {
          const char = urlWithParams.includes('?') ? '&' : '?'
          urlWithParams += `${char}${key}=${JSON.stringify(value)}`
        }
      })
    }

    return authedAxios
      .get(urlWithParams)
      .then((res) => {
        setData(res.data)
        setIsLoading(false)
      })
      .catch((e) => {
        setHasLoadError(true)
        setIsLoading(false)
      })
  }

  useEffect(() => {
    if (shouldDelayCall) return

    if (shouldPreventCall) {
      setIsLoading(false)
      return
    }

    fetchData()
  }, [shouldPreventCall, shouldDelayCall, JSON.stringify(filters), url])

  return {
    data,
    isLoading,
    hasLoadError,
    setIsLoading,
    setData,
    refetch: fetchData,
  }
}

export default useGenericEndpoint
